var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('b-container',[_c('AppHeader')],1),_c('b-container',[_c('div',{staticClass:"pb-4"},[_c('AppMenu')],1)]),_c('div',{staticClass:"cuerpo pt-1 mx-4 my-5"},[_c('router-view')],1),_c('div',[_c('AppFooter')],1),_c('loading',{ref:"loading"}),_c('alerta',{ref:"alerta"}),_c('modal',{ref:"modal"}),_c('modalC')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }